import React from 'react'
import {AppBar} from '@material-ui/core'
import {ThemeProvider, withStyles} from '@material-ui/core/styles'
import { MuiPickersUtilsProvider } from '@material-ui/pickers'
import DateFnsUtils from '@date-io/date-fns'
import { BrowserRouter as Router, Switch, Route } from 'react-router-dom'
import { createBrowserHistory } from "history"
import Home from './scenes/Home'
import IndividualPreRegister from './scenes/IndividualPreRegister'

import theme from './theme'
import Logo from './components/Logo'
import Individual from './scenes/Individual'
import Company from './scenes/Company'
import Partner from './scenes/Partner'

const history = createBrowserHistory()

const styles = (theme) => ({
  formWrapper: {
    background: 'linear-gradient(45deg, rgba(0,0,0,1) 0%, rgba(32,29,29,1) 100%)',
    display: 'flex',
    justify: 'flex-start',
    alignContent: 'flex-start',
    position: 'relative',
    width: '100%',
    height: '100vh',
    overflow: 'auto',
    backgroundSize: 'cover',
    flexDirection: 'column'
  },
  topBar: {
    display: 'flex',
    justifyContent: 'center',
    flexDirection: 'row',
    alignItems: 'center',
    height: 85,
    borderBottom: 'solid 1px rgba(32,29,29,1)'
  }
})

function App({classes}) {
  return (
    <ThemeProvider theme={theme}>
      <MuiPickersUtilsProvider utils={DateFnsUtils}>
        <div className={classes.formWrapper}>
          <AppBar color="transparent" elevation={0} className={classes.topBar} position="static">
            <Logo />
          </AppBar>
          <Router history={history}>
            <Switch>
              <Route path="/parceiros">
                <Partner />
              </Route>
              <Route path="/empresas">
                <Company />
              </Route>
              <Route path="/individual">
                <Individual />
              </Route>
              <Route path="/pre-cadastro">
                <IndividualPreRegister />
              </Route>
              <Route path="/">
                <Home />
              </Route>
            </Switch>
          </Router>
        </div>
      </MuiPickersUtilsProvider>
    </ThemeProvider>
  )
}

export default withStyles(styles)(App)
